export const siteInfo = {
  brand: "91视频在线免费观看",
  slogan: "最新高清视频资源在线播放平台",
  intro:
    "91视频在线免费观看是一个聚合高清影视内容的浏览平台，涵盖电影、电视剧、综艺等多个类别，致力于为用户提供清晰的内容分类、及时的更新信息与顺畅的浏览体验。",
  introDetail:
    "我们希望每一位影视爱好者，都能在最短的时间里找到自己想看的内容。通过分类筛选、关键词搜索与个性化推荐，你可以轻松发现新片、追更剧集，也能重温那些让人难忘的经典片段。",
  email: "hello@example-video.com",
  workingHours: "周一至周五 9:00 - 18:00",
  copyright: "本网站所有影视信息与图片均为虚构示例，仅用于展示，无任何版权指向。",
  stats: [
    { label: "影视条目", value: "10,000+" },
    { label: "覆盖地区", value: "20+" },
    { label: "每日更新", value: "200+" },
    { label: "内容分类", value: "30+" },
  ],
};